import { IngredientWithDosing } from '../../components/shoppingCart/types';
import { AnalyticsIngredientListName, AnalyticsListName } from '../../utils/analytics/analytics';
import { OrderItem } from './OrderItem';

export class HistoricalOrderItem extends OrderItem {
  inactive = false;
  includesInactiveIngredients = false;
  recipeOutdated = false;

  public static fromOrderItem(item: OrderItem): HistoricalOrderItem {
    const newItem = new HistoricalOrderItem();

    newItem.uuid = item.uuid;
    newItem.productID = item.productID;
    newItem.quantity = item.quantity;
    newItem.sizeId = item.sizeId;
    newItem.recipe = item.recipe.map((ingredient) => ({ ...ingredient }));
    newItem.menuImagePath = item.menuImagePath;
    newItem.menuImagePathMobile = item.menuImagePathMobile;
    newItem.additionalText = item.additionalText;
    newItem.discount = item.discount;
    newItem.discountedPrice = item.discountedPrice;
    newItem.discountedProductQuantity = item.discountedProductQuantity;
    newItem.price = item.price;
    newItem.name = item.name;
    newItem.productCategoryId = item.productCategoryId;
    newItem.productCategoryName = item.productCategoryName;
    newItem.comboId = item.comboId;
    newItem.comboCampaignCode = item.comboCampaignCode;
    newItem.productSizes = item.productSizes;
    newItem.appliedCampaigns = item.appliedCampaigns;
    newItem.slug = item.slug;
    newItem.imagepath = item.imagepath;
    newItem.imagepathMobile = item.imagepathMobile;
    newItem.description = item.description;
    newItem.basePrice = item.basePrice;
    newItem.minimumPrice = item.minimumPrice;
    newItem.priceCorrection = item.priceCorrection;
    newItem.hasMinimumPrice = item.hasMinimumPrice;
    newItem.hasFixedMinimumPrice = item.hasFixedMinimumPrice;
    newItem.ingredientMeta = [...item.ingredientMeta];
    newItem.editable = item.editable;
    newItem.hasExtraIngredients = item.hasExtraIngredients;
    newItem.custom = item.custom;
    newItem.backgroundColor = item.backgroundColor;
    newItem.ingredientSlots = item.ingredientSlots.map((slot) => slot.clone());
    newItem.ingredients = item.ingredients.map((ingredient) => ({
      ...ingredient,
      addedFrom: AnalyticsIngredientListName.Recipe,
    }));
    newItem.disabledIngredients = item.disabledIngredients.map((ingredient) => ({
      ...ingredient,
    }));
    newItem.customized = item.customized;
    newItem.recommendedIngredients = item.recommendedIngredients?.map((ingredient) => ({
      ...ingredient,
    }));
    newItem.inactive = false;
    newItem.includesInactiveIngredients = false;
    newItem.recipeOutdated = false;
    newItem.isOutOfStock = item.isOutOfStock;
    newItem.addedFrom = { name: AnalyticsListName.OrderAgain };
    newItem.modificationLocked = item.modificationLocked;

    return newItem;
  }

  public setIngredients(ingredients: IngredientWithDosing[]): void {
    super.setIngredients(ingredients);
    this.includesInactiveIngredients = ingredients.some((i) => i.inactive);
  }

  public getWarningText(restaurantSelected = false): string | undefined {
    let warningText = undefined;

    if (this.inactive) {
      warningText = restaurantSelected
        ? 'Tuote ei kuulu valitsemasi ravintolan valikoimaan'
        : 'Tuotetta ei ole enää saatavilla.';
    } else if (this.includesInactiveIngredients || this.recipeOutdated) {
      warningText = 'Täytteiden saatavuus tai tuotteen resepti on muuttunut.';
    }

    return warningText;
  }
}
